import React, { useEffect, useState, useCallback } from "react";
import Slider from "../components/Slider/Slider";
import { FaGear, FaRotateLeft } from "react-icons/fa6";
import Modal from "./Modal/Modal";
import GalleryImagePair from "../components/GalleryImagePair/GalleryImagePair";
import io, { Socket } from "socket.io-client";
import axios from "axios";
import config from "../config/config.json";

// console.log("CONFIG:", config)

const serverUrl = `https://${config.ip}:${config.port}`;
const serverSocket = io(serverUrl);
const endpoint = {
  printQueue: `${serverUrl}/api/printqueue`,
};

const Gallery = () => {
  const [imagePairs, setImagePairs] = useState({});
  const [imageColumns, setImageColumns] = useState(2);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enableSingleImageOption, setEnableSingleImageOption] = useState(true);
  const [selectedImages, setSelectedImages] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [imageBuffer, setImageBuffer] = useState({});
  const [sharpQueueLength, setSharpQueueLength] = useState(0);

  const toggleEnableSingleImage = () => {
    setEnableSingleImageOption(!enableSingleImageOption);
  };
  const fetchImages = useCallback(
    async (endpoint = "images") => {
      console.log(`${endpoint}: Fetching images...`);
      console.log(`${config.production.apiUrl}/api/${endpoint}`);
      try {
        const response = await axios.get(
          `${config.production.apiUrl}/api/${endpoint}`
        );
        const newDataObject = response.data;
        console.log("new data obj: ", newDataObject);
        console.log(newDataObject);
        const newData = Object.values(newDataObject); // 👈 Fix: convert object to array

        if (newData.length === 0) {
          setIsLoading(false);
          return;
        }

        setImagePairs((currentPairs) => {
          const updatedPairs = { ...currentPairs };
          newData.forEach((pair) => {
            if (!updatedPairs[pair.id]) {
              updatedPairs[pair.id] = {
                ...pair,
                id: pair.id,
                beforeImagePath: "",
                afterImagePath: "",
                selected: false,
              };
            }
          });
          return updatedPairs;
        });
      } catch (err) {
        setError("Failed to fetch images");
        console.error("Fetch error:", err);
      }

      setIsLoading(false);
      console.log(`${endpoint}: Fetch complete`);
    },
    [imagePairs]
  );

  let imagePairPredisplayBuffer = [];

  useEffect(() => {
    serverSocket.on("imageUpdate", (data) => {
      const imageUpdate = JSON.parse(data); // Assuming data is a JSON string
      console.log("ws:", imageUpdate);

      // Create a new image pair object
      const newImagePair = {
        id: imageUpdate.id,
        beforeImage: imageUpdate.beforeImage,
        afterImage: imageUpdate.afterImage,
        selected: false, // Assuming you want to initialize it as not selected
      };

      imagePairPredisplayBuffer.push(newImagePair);
      console.log("buffer:", imagePairPredisplayBuffer.length, imageColumns);

      if (imagePairPredisplayBuffer.length >= imageColumns) {
        // Update imagePairs state with the new image pair
        setImagePairs((currentPairs) => ({
          ...currentPairs,
          [imageUpdate.id]: newImagePair,
        }));

        imagePairPredisplayBuffer = [];
      }
    });

    serverSocket.on("connect", () => {
      console.log("Connected to server");
    });

    serverSocket.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    return () => serverSocket.off("imageUpdate");
  }, []);

  // Scrolls to the newest images
  const scrollToNewest = () => {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    }, 0);
  };

  useEffect(() => {
    fetchImages("allimages");
  }, []);

  useEffect(() => {
    console.log("selected:", selectedImages);
  }, [selectedImages]);

  const toggleImageSelection = useCallback(
    (imagePair) => {
      if (
        selectedImages[imagePair.id] ||
        Object.keys(selectedImages).length < config.maxPhotoPrints
      ) {
        const updatedPairs = {
          ...imagePairs,
          [imagePair.id]: { ...imagePair, selected: !imagePair.selected },
        };

        setImagePairs((currentPairs) => {
          // Clone the current state to avoid direct mutation
          const updatedPairs = { ...currentPairs };
          // Update the specific image pair's selected status
          updatedPairs[imagePair.id] = {
            ...imagePair,
            selected: !imagePair.selected,
          };
          return updatedPairs;
        });

        const updatedSelectedImages = { ...selectedImages };

        if (updatedSelectedImages[imagePair.id]) {
          delete updatedSelectedImages[imagePair.id];
        } else {
          updatedSelectedImages[imagePair.id] = imagePair;
        }
        setSelectedImages(updatedSelectedImages);
      }
    },
    [imagePairs, selectedImages]
  );

  const clearSelectedImages = () => {
    const updatedPairs = { ...imagePairs };
    Object.keys(selectedImages).forEach((key) => {
      if (updatedPairs[key]) {
        updatedPairs[key].selected = false;
      }
    });

    setImagePairs((currentPairs) => {
      const updatedPairs = { ...currentPairs };
      Object.keys(selectedImages).forEach((key) => {
        if (updatedPairs[key]) {
          updatedPairs[key].selected = false; // Deselect the image
        }
      });
      return updatedPairs;
    });

    setSelectedImages({});
    console.log("selections cleared");
  };

  const handlePrint = async () => {
    const selectedImagePaths = selectedImages;
    const endpoint = "print";
    clearSelectedImages();
    const response = await fetch(
      `https://${config.ip}:${config.port}/api/${endpoint}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ imagePaths: selectedImagePaths }),
      }
    );
    // const responseMessage = await response.json().message;
    // console.log("Response message:", responseMessage);

    // if (response.status !== 201) {
    //   console.log("print failed");
    //   return;
    // }
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <>
      <div className="relative z-0">
        <div
          id="topbar"
          className="fixed top-0 z-50 left-0 flex items-center justify-between w-full p-2 bg-base-900"
        >
          <h1 className="ml-1">Photo Gallery</h1>
          {/* <p>Queue: {sharpQueueLength}</p> */}
          <p>{Object.keys(imagePairs).length}</p>
          <FaGear
            onClick={() => toggleModal()}
            className="mr-3 text-2xl transition-transform cursor-pointer opacity-10 hover:rotate-90"
          />
        </div>
        {error && <div>{error}</div>}
        <div id="gallery" className="min-h-lvh px-1 pt-12 pb-16">
          {Object.values(imagePairs)
            .sort((a, b) => b.id.localeCompare(a.id))
            .map((pair) => (
              <GalleryImagePair
                key={pair.id}
                id={pair.id}
                pairObject={pair}
                beforeImagePath={pair.before_image_path}
                beforeImage={pair.before_original_path}
                afterImagePath={pair.after_image_path}
                afterImage={pair.after_original_path}
                toggleImageSelection={toggleImageSelection}
                columns={imageColumns}
              />
            ))}
        </div>
        <div
          id="action-bar"
          className="fixed bottom-0 left-0 flex w-full p-2 bg-base-900 pr-4"
        >
          <div className="relative block slider-wrapper">
            <Slider
              imageColumns={imageColumns}
              changeImageColumns={setImageColumns}
              enableSingleImageOption={enableSingleImageOption}
            />
          </div>

          <button
            className="ml-auto mr-auto button btn bg-indigo-950 bg-opacity-40"
            onClick={scrollToNewest}
          >
            To Newest
          </button>
          <button className="btn text-xs" onClick={clearSelectedImages}>
            <span className="icon icon__reset">
              <FaRotateLeft />
            </span>
            Clear selected
          </button>
          <button
            className="ml-2 button button-primary btn btn-primary"
            onClick={handlePrint}
            disabled={!Object.keys(selectedImages).length}
          >
            Print{" "}
            {`${Object.keys(selectedImages).length}/${config.maxPhotoPrints}`}{" "}
            Selected Images
          </button>
        </div>
        <span className="absolute top-0 bottom-0 left-0 w-full h-full bg-black pointer-events-none bg-opacity-30 -z-10"></span>
        <span className="absolute top-0 bottom-0 left-0 w-full h-full pointer-events-none bg-gradient-to-br from-fuchsia-950 via-pink-800 to-orange-700 -z-20 opacity-50"></span>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={toggleModal}
        settings={enableSingleImageOption}
        toggleSettings={toggleEnableSingleImage}
      />
    </>
  );
};

export default Gallery;
